import {SubjektasApi} from "./subjektas.api";
import {GiiSrautasApi} from "./gii-srautas.api";
import {GiiRegKoregavimasApi} from "./gii-reg-koregavimas.api";

export class GiiRegistracijaApi {
  id!: number | null;
  regData: Date | null | undefined;
  isregData: Date | null | undefined;
  busena: string = '';
  tiektaNuo: any;
  tiektaIki: any;
  srautoId: any;
  srautoKodas: string = '';
  clKodas: string = '';
  sustabdytaNuo!: Date | null;
  sustabdytaIki: any;
  sustabdymoPriezastis: any;
  subjektasApi: SubjektasApi = new SubjektasApi();
  giiSrautasApiList: GiiSrautasApi[] = [];
  giiRegKoregavimasApiList: GiiRegKoregavimasApi[] = [];
}
